import {checkAuthority} from "../api/user";
import {setStore} from "../utils";

export default {
  methods: {
    getUserAuthority() {
      return new Promise((resolve, reject) => {
        checkAuthority().then(res => {
          console.log('当前用户的权限', res)
          setStore('userAuthority',JSON.stringify(res))
          this.$store.dispatch("setUserAuthority", res);
          resolve(res);
        }, e => {
          reject(e);
        });
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/userAuthority.js